import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-page-index',
  templateUrl: './page-index.component.html',
  styleUrls: ['./page-index.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageIndexComponent implements OnInit {

  constructor() { }



  ngOnInit(): void {
  }

}
